import React from "react";
import MarketOverviewTable from "../MarketOverviewTable";
import { useMarketOverviewData } from "../../../context/MarketOverviewContext";
import { DEFAULT_CATALYSTS } from "../../../constants/sections";

const ForexTab = () => {
    const { rows } = useMarketOverviewData();
    const data = rows.filter(row => (row.category || row.Category) === "Forex");
    const FOREX_ORDER = ["EURUSD", "USDJPY", "GBPUSD", "USDCAD", "AUDUSD", "USDCHF"];
    return <MarketOverviewTable data={data} title="Forex Analysis" defaultRowData={{ Category: "Forex" }} defaultCatalysts={DEFAULT_CATALYSTS.Forex} customSortOrder={FOREX_ORDER} />;
};

export default ForexTab;
